import { RepositoryIdValue } from 'yeself-common/typings/addons/assetAddon/AssetAddonCommon';
import { ApplicationId } from 'yeself-common/typings/application/Application';
import { LayerId } from 'yeself-common/typings/guide/LayerCommon';
import { AddonSystemKeyValue, AssetId } from 'yeself-common/typings/guide/recording/Recording';

export const FETCH_RECORDING_OUTPUTS_REQUEST = 'recording/FETCH_RECORDING_OUTPUTS_REQUEST';
export const FETCH_RECORDING_OUTPUTS_SUCCESS = 'recording/FETCH_RECORDING_OUTPUTS_SUCCESS';
export const FETCH_RECORDING_OUTPUTS_FAIL = 'recording/FETCH_RECORDING_OUTPUTS_FAIL';
export const GENERATE_RECORDING_OUTPUTS_REQUEST = 'recording/GENERATE_RECORDING_OUTPUTS_REQUEST';
export const GENERATE_RECORDING_OUTPUTS_SUCCESS = 'recording/GENERATE_RECORDING_OUTPUTS_SUCCESS';
export const GENERATE_RECORDING_OUTPUTS_FAIL = 'recording/GENERATE_RECORDING_OUTPUTS_FAIL';

type FetchRecordingOutputsRequestAction = {
    type: typeof FETCH_RECORDING_OUTPUTS_REQUEST;
    payload: {
        applicationId: ApplicationId;
        guideId: LayerId;
        assetId: AssetId;
        addonSystemKey: AddonSystemKeyValue;
        repositoryId: RepositoryIdValue;
        message: Record<string, unknown>;
    };
};

export type RecordingActionTypes = FetchRecordingOutputsRequestAction;
